import { render, staticRenderFns } from "./notice-modal.vue?vue&type=template&id=fdea2c84&scoped=true&"
import script from "./notice-modal.vue?vue&type=script&lang=js&"
export * from "./notice-modal.vue?vue&type=script&lang=js&"
import style0 from "./notice-modal.vue?vue&type=style&index=0&id=fdea2c84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdea2c84",
  null
  
)

export default component.exports